import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import RadioGroup from './../RadioGroup';
import Toggle from '../Toggle';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view07ImageOptions } from './views/exterior_view07'

class X56Deck extends Component {
    constructor(props) {
        super(props);
        this.handleDeckChange = this.handleDeckChange.bind(this);
        this.handleTeakOnSideDecksChange = this.handleTeakOnSideDecksChange.bind(this);
        this.handleTeakOnCoachroofChange = this.handleTeakOnCoachroofChange.bind(this);
        this.handleSolarPanelsChange = this.handleSolarPanelsChange.bind(this);
    }


    handleDeckChange(newValue) {
        let configuration = this.props.configuration;
        configuration.Deck = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleTeakOnSideDecksChange(event) {
        let configuration = this.props.configuration;
        configuration.TeakOnSideDecks = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleTeakOnCoachroofChange(event) {
        let configuration = this.props.configuration;
        configuration.TeakOnCoachroof = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleSolarPanelsChange(event) {
        let configuration = this.props.configuration;
        configuration.SolarPanels = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = exterior_view07ImageOptions;
        
        let image = (
            <ConfiguratorImage boat="X5_6" configuration={this.props.configuration} options={imageOptions} />
        );

        return (
            <ConfiguratorSection image={image}>
                
                <ConfiguratorOption>

                    <h1><Trans defaults='Deck & cockpit' /></h1>
                    <p><Trans defaults='Standard on the X5<sup>6</sup> is genuine teak on cockpit floor and seats. Genuine teak is with black caulkings and optional is Flexiteek finish with grey stripes.' /></p>

                    <RadioGroup label={this.props.t("Deck material:")} options={this.props.deckOptions} value={this.props.configuration.Deck} onChange={this.handleDeckChange} />

                    <h3><Trans defaults='Deck options:' /></h3>


                    <Toggle checked={this.props.configuration.TeakOnSideDecks.value === 2} onChange={this.handleTeakOnSideDecksChange}>
                        <Trans defaults='{{wood}} on side decks' values={{ 'wood': (this.props.configuration.Deck.value === 1) ? 'Teak' : 'Flexiteek' }} />
                    </Toggle>
                    <Toggle checked={this.props.configuration.TeakOnCoachroof.value === 2} onChange={this.handleTeakOnCoachroofChange}>
                        <Trans defaults='{{wood}} on coachroof' values={{ 'wood': (this.props.configuration.Deck.value === 1) ? 'Teak' : 'Flexiteek' }} />
                    </Toggle>

                    <Toggle checked={this.props.configuration.SolarPanels.value === 2} onChange={this.handleSolarPanelsChange}>
                        <Trans defaults='Solar panels' />
                    </Toggle>

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X56Deck);


// WEBPACK FOOTER //
// ./src/X56/X56Deck.js